import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-stories',
  templateUrl: './stories.component.html',
  styleUrls: ['./stories.component.scss'],
})
export class StoriesComponent implements OnInit {
  currentUser = this.authService.currentUser;
  unsub1;
  constructor(
    public authService: AuthService,
  ) {
    this.unsub1 = this.authService.currentAccount.subscribe(async (currentUser) => {  this.currentUser = currentUser; });
  }

  async ngOnInit() {

  }

  ionviewDidLeave() {
    this.unsub1.unsubscribe();
  }

}
